export default __webpack_public_path__ + "static/media/filter.9931407d.svg";